const CardListStyle = `

    * {
        font-family: 'Montserrat', sans-serif;
     }

    :host .list--card .btn--secondary.list__link-button{
        margin-top:0;
        padding: 24px 0;
        font-size:16px;
        font-weight: 700;
        color: #0774E7
     }

     :host .row.false{
        margin:0 !important;
     }
     :host .row.false > .col{
        padding:0 !important;
     }

     :host .list--card li {
        border-bottom: 0  !important;  
        padding:0;
        margin-bottom: 16px;
     }
     :host .col-full, :host(:not([dark])) .col-full{
        padding-left: 0 !important;
     }
     :host .list--card .list__item.clickable {
        padding:4px 8px;
        border-radius: 12px;
        border: 1px solid #0774E7;
     }
     
     :host .list--card .radio-item__icon{
        border-color:#0774E7; 
     }

     :host .card-in-list .card-preview__card-art{
        margin: 0;
     }

     :host .list--card .add-card-list-item .list__item.clickable{
        border-radius:0;
        border-left:0;
        border-right:0;
        border-color:#B8C1CC;
        padding:15px 0;
     }
     :host .list--card li > .row.row-padding-left-radio{
        width:100%;
        padding-top:20px;
        padding-left: 5px;
        margin:0;
        display:flex;
     }
     :host .list--card li > .row.row-padding-left-radio .btn--secondary{
        margin:0;
        font-size: 16px;
        font-weight: 600;
        color:#0774E7;
        text-decoration: none;
        display:flex;
        align-items:center;
     }

     :host .list--card li > .row.row-padding-left-radio .btn--secondary:before{
        content:'';
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxtYXNrIGlkPSJtYXNrMF8xODQ5Xzc4MDYzIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjI5Mjg5IDkuNzkyODlDNS45MDIzNyAxMC4xODM0IDUuOTAyMzcgMTAuODE2NiA2LjI5Mjg5IDExLjIwNzFMMTEuMjkyOSAxNi4yMDcxQzExLjY4MzQgMTYuNTk3NiAxMi4zMTY2IDE2LjU5NzYgMTIuNzA3MSAxNi4yMDcxTDE3LjcwNzEgMTEuMjA3MUMxOC4wOTc2IDEwLjgxNjYgMTguMDk3NiAxMC4xODM0IDE3LjcwNzEgOS43OTI4OUMxNy4zMTY2IDkuNDAyMzcgMTYuNjgzNCA5LjQwMjM3IDE2LjI5MjkgOS43OTI4OUwxMiAxNC4wODU4TDcuNzA3MTEgOS43OTI4OUM3LjMxNjU4IDkuNDAyMzcgNi42ODM0MiA5LjQwMjM3IDYuMjkyODkgOS43OTI4OVoiIGZpbGw9ImJsYWNrIi8+DQo8L21hc2s+DQo8ZyBtYXNrPSJ1cmwoI21hc2swXzE4NDlfNzgwNjMpIj4NCjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iIzA3NzRFNyIvPg0KPC9nPg0KPC9zdmc+DQo=);
        width:24px;
        height:24px;
        background-size: contain;
        display:block;
        margin-right: 15px;
     }
     :host .list--card .add-card-list-item .list__item.clickable .list__item-content p{
        font-size:0;
        display: flex;
     }
     :host .list--card .add-card-list-item .list__item.clickable .list__item-content p:before{
        content:'Adicionar novo cartão';
        font-size: 16px;
        font-weight: 600;
        color:#0774E7;
     }
     :host .list--card .add-card-list-item .list__item.clickable .radio-item__icon{
        border-color: transparent;

    }
     :host .list--card .add-card-list-item .list__item.clickable .radio-item__icon:before{
        content:'';
        width:24px;
        height:24px;
        background-size: contain;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxtYXNrIGlkPSJtYXNrMF8xODQ5Xzc4MDcxIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPg0KPHBhdGggZD0iTTE3IDEyQzE3IDEyLjU1MjMgMTYuNTUyMyAxMyAxNiAxM0gxM1YxNkMxMyAxNi41NTIzIDEyLjU1MjMgMTcgMTIgMTdDMTEuNDQ3NyAxNyAxMSAxNi41NTIzIDExIDE2VjEzSDhDNy40NDc3MiAxMyA3IDEyLjU1MjMgNyAxMkM3IDExLjQ0NzcgNy40NDc3MiAxMSA4IDExSDExVjhDMTEgNy40NDc3MiAxMS40NDc3IDcgMTIgN0MxMi41NTIzIDcgMTMgNy40NDc3MiAxMyA4VjExSDE2QzE2LjU1MjMgMTEgMTcgMTEuNDQ3NyAxNyAxMloiIGZpbGw9ImJsYWNrIi8+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIgMTJDMiA2LjQ3NzE1IDYuNDc3MTUgMiAxMiAyQzE3LjUyMjggMiAyMiA2LjQ3NzE1IDIyIDEyQzIyIDE3LjUyMjggMTcuNTIyOCAyMiAxMiAyMkM2LjQ3NzE1IDIyIDIgMTcuNTIyOCAyIDEyWk0xMiA0QzcuNTgxNzIgNCA0IDcuNTgxNzIgNCAxMkM0IDE2LjQxODMgNy41ODE3MiAyMCAxMiAyMEMxNi40MTgzIDIwIDIwIDE2LjQxODMgMjAgMTJDMjAgNy41ODE3MiAxNi40MTgzIDQgMTIgNFoiIGZpbGw9ImJsYWNrIi8+DQo8L21hc2s+DQo8ZyBtYXNrPSJ1cmwoI21hc2swXzE4NDlfNzgwNzEpIj4NCjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iIzA3NzRFNyIvPg0KPC9nPg0KPC9zdmc+DQo=);
   
        display:block;

    }



`;
export default CardListStyle;
